import React from 'react';
import { useSetRecoilState } from 'recoil';
import styled from 'styled-components';
import UserInfoCard from './UserInfoCard';
import Button from '@components/dataEntry/button/Button';
import { registerOpenState } from '@atom/modal/modal';
import useValidLogin from '@hooks/useValidLogin';

const UserSecWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 8px;
`;
const BtnWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%; ;
`;

type Props = {
  style?: React.CSSProperties;
};
function UserInfoSec({ style }: Props) {
  const isValidLogin = useValidLogin();
  const setOpenModal = useSetRecoilState(registerOpenState);

  return (
    <UserSecWrapper style={{ ...style }}>
      {isValidLogin ? (
        <UserInfoCard />
      ) : (
        <BtnWrap>
          <Button shape="stroke" onClick={() => setOpenModal(true)}>
            로그인
          </Button>
        </BtnWrap>
      )}
    </UserSecWrapper>
  );
}

export default UserInfoSec;
